/** Product tags that restrict a product to standard shipping only. */
export const STANDARD_SHIPPING_ONLY_PRODUCT_TAGS = ['dc:ca', 'shipping:standard-only'];
